<template>
    <div class="current-day" v-if="days && days.length > 0">
            <b-row>
                <b-col cols="12">
                <template v-if="debug">
                    <table>
                        <thead>
                        <tr>
                            <th>Day</th>
                            <th>Type</th>
                            <th>Price</th>
                            <th v-for="(t,idt) in days[0].sales" :key=idt> 0{{idt+1}}</th>
                        </tr>
                        </thead>
                        <tbody class="stripped">
                        <template v-for="(day,index) in days">
                            <tr v-if="index<dayNum" :key="`rp-${index}`">
                                <td>{{index+1}}</td>
                                <td> Purchase</td>
                                <td :style="{color:'red'}"> ${{day.supplierPrice}}</td>
                                <td v-for="(p,idp) in day.purchase" :key="idp">
                                    <span :style="{color: p.qty===0 ? 'black' : (p.paid ? 'blue': 'red')}">{{p.qty}}</span>
                                </td>
                            </tr>
                            <tr v-if="index<dayNum" :key="`rs-${index}`">
                                <td>{{index+1}}</td>
                                <td> Sale</td>
                                <td :style="{color:'green'}"> ${{day.customerPrice}}</td>
                                <td v-for="(s,ids) in day.sales" :key="ids">
                                    <span :style="{color: s.qty===0 ? 'black' : (s.paid ? 'blue':'green')}">{{s.qty}}</span>
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <td>all</td>
                            <td> balance</td>
                            <td>---</td>
                            <td v-for="(account,index) in accounts" v-bind:key="index">
                                ${{account}}
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </template>
                </b-col>
            </b-row>
            <b-row v-if="['Supplier', 'Customer'].includes(dayStage)">

<b-col class="table-overflow">
                <table class="text-center">
                <tbody>
                <template v-if="dayStage==='Supplier'">
                    <tr v-if="$root.store.currentDay < $root.store.nboDays">
                        <td>
                            <h3 class="mt-4">Order</h3>
                        </td>
                    </tr>
                    <tr v-if="$root.store.currentDay < $root.store.nboDays">
                        <th>Group N°</th>
                        <th v-for="(t,idt) in days[0].sales" :key=idt> 0{{idt+1}}</th>
                    </tr>
                    <tr v-if="$root.store.currentDay < $root.store.nboDays">
                        <td>B. Purchase Order Quantity</td>
                        <td v-for="(p,pidx) in days[dayIndex].purchase" v-bind:key="`pqty-${pidx}`">
                            <b-form-select dir="rtl" :tabindex="pidx + 1" :ref="`Supplier-${pidx}`" v-model.number="p.qty">
                                <option>0</option>
                                <option>5</option>
                                <option>10</option>
                            </b-form-select>
                        </td>
                    </tr>
                    <tr v-if="$root.store.currentDay < $root.store.nboDays">
                        <td>Purchase total amount</td>
                        <td v-for="(s,sidx) in days[dayIndex].purchase" v-bind:key="`pqty-${sidx}`">
                            $ {{s.qty * days[dayIndex].supplierPrice}}
                        </td>
                    </tr>
                    <tr v-if="dayIndex>0">
                        <td><h3 class="mt-4">Pick-up</h3></td>
                    </tr>
                    <tr v-if="dayIndex>0">
                        <th>Group N°</th>
                        <th v-for="(t,idt) in days[0].sales" :key=idt> 0{{idt+1}}</th>
                    </tr>
                    <tr v-if="dayIndex>0">
                        <td>E. Invoice of day {{dayIndex}}</td>
                        <td v-for="(bill,indBill) in days[dayIndex-1].purchase" v-bind:key="indBill">
                            <b-button :tabindex="indBill + 1 + $root.store.nboTeams" :pressed.sync="bill.paid" variant="outline-primary" size="lg" :disabled="billAmount(dayIndex-1, indBill) == 0">
                                <span v-bind:style="{color:bill.paid ? 'white':'#F7941D'}">
                                ${{billAmount(dayIndex-1, indBill)}}
                                </span>
                            </b-button>
                        </td>
                    </tr>
                    <tr v-if="dayIndex>0">
                        <td>Purchase Order Quantity</td>
                        <td v-for="(s,sidx) in days[dayIndex-1].purchase" v-bind:key="`pqty-${sidx}`">
                            {{s.qty}}
                        </td>
                    </tr>

                </template>
                <template v-if="dayStage==='Customer'">
                    <tr>
                        <td>
                            <h3 class="mt-4">Delivery</h3>
                        </td>
                    </tr>
                    <tr>
                        <th>Group N°</th>
                        <th v-for="(t,idt) in days[0].sales" :key=idt> 0{{idt+1}}</th>
                    </tr>
                    <tr>
                        <td>B. Box sales quantity</td>
                        <td v-for="(s,sidx) in days[dayIndex].sales" v-bind:key="`sqty-${sidx}`">
                            <b-form-select dir="rtl" :tabindex="sidx + 1" :ref="`Customer-${sidx}`" v-model.number="s.qty">
                                <option>0</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                            </b-form-select>
                        </td>
                    </tr>
                    <tr>
                        <td>Sales total amount</td>
                        <td v-for="(s,sidx) in days[dayIndex].sales" v-bind:key="`sqty-${sidx}`">
                            $ {{s.qty * days[dayIndex].customerPrice}}
                        </td>
                    </tr>
                    <tr v-if="dayIndex>1">
                        <td><h3 class="mt-4">Payment</h3></td>
                    </tr>
                    <tr v-if="dayIndex>1">
                        <th>Group N°</th>
                        <th v-for="(t,idt) in days[0].sales" :key=idt> 0{{idt+1}}</th>
                    </tr>
                    <tr v-if="dayIndex>1">
                        <td>C. Payment of day {{dayIndex-1}} sales</td>
                        <td v-for="(invoice, indInvoice) in days[dayIndex-2].sales" v-bind:key="indInvoice">
                            <b-button :tabindex="indInvoice + 1 + $root.store.nboTeams" :pressed.sync="invoice.paid" variant="outline-primary" :disabled="invoiceAmount(dayIndex-2, indInvoice) === 0">
                                <span v-bind:style="{color:invoice.paid ? 'white':'#5185B4'}">
                                ${{invoiceAmount(dayIndex-2, indInvoice)}}
                                </span>
                            </b-button>
                        </td>
                    </tr>

                </template>
                </tbody>
            </table>
</b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col>
                    <b-button v-if="dayIndex > 0 || dayStage === 'Customer'" block variant="outline-warning" @click="$emit('previous')">Previous</b-button>
                </b-col>
                <b-col>
                    <b-button v-if="$root.hasNext || dayStage === 'Supplier'" block variant="primary" @click="$emit('next')">Next</b-button>
                    <b-button v-if="!$root.hasNext && dayStage === 'Customer' && dayStage !== 'GameEnd'" block variant="primary" @click="$emit('end')">End Game</b-button>
                    <b-button v-if="!$root.hasNext && ['GameEnd', 'Ranking'].includes(dayStage)" block variant="primary" @click="$emit('ranking')">Ranking</b-button>
                </b-col>
            </b-row>
            <b-row v-if="dayStage === 'Supplier'">
                <b-col class="mt-4">
                    <strong>Manufacturing phase</strong>
                    <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#d6edfc" d="M13.3 7.7L0 0v15.3z"/></svg>
                    <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#EC008C" d="M13.3 7.7L0 0v15.3z"/></svg>
                    <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#d6edfc" d="M13.3 7.7L0 0v15.3z"/></svg>
                    <p>Tip: Produce as soon as possible</p>
                </b-col>
            </b-row>
            <img v-if="dayStage === 'Supplier'" class="deco" src="@/assets/pods.svg">
            <img v-if="dayStage === 'Customer'" class="deco" src="@/assets/Asset-52.png">
    </div>
</template>

<script>
    export default {
        name: "CurrentDay",
        props: {
            dayNum: Number,
            dayStage: String
        },
        methods: {
            billAmount(dayIndex, teamIndex) {
                let day = this.days[dayIndex];
                return day.supplierPrice * Number(day.purchase[teamIndex].qty);
                // balance => * (day.purchase[t].paid ? 0 : 1);
            },
            invoiceAmount(dayIndex, teamIndex) {
                let day = this.days[dayIndex];
                return day.customerPrice * Number(day.sales[teamIndex].qty);
                // balance => * (day.sales[t].paid ? 0 : 1);
            }
        },
        computed: {
            debug() {
                return 'debug' in this.$route.query;
            },
            days() {
                return this.$root.$data.store.days;
            },
            dayIndex() {
                return this.dayNum - 1;
            },
            accounts() {
                //debugger;
                let _calc_account = Array(this.$root.$data.store.nboTeams);
                let days = this.days;
                for (let t = 0; t < _calc_account.length; t++) {
                    _calc_account[t] = 0;
                    for (let d = 0; d < this.dayIndex; d++) {
                        _calc_account[t] -= days[d].supplierPrice * Number(days[d].purchase[t].qty) * (days[d].purchase[t].paid ? 0 : 1);
                        _calc_account[t] += days[d].customerPrice * Number(days[d].sales[t].qty) * (days[d].sales[t].paid ? 0 : 1);
                    }
                }
                return _calc_account;
            }
        }
    }
</script>

<style scoped>

    .chevron {
        padding: 0 1px;
        height: 18px;
    }
    .deco {
        opacity: 0.4;
        width: 80%;
        max-width: 300px;
        display: block;
        margin: 40px auto;
    }

    tbody.stripped tr:nth-child(odd) {
        background-color: #f2f2f2;
    }
    .current-day {
        font-size: large;
    }
    .table-overflow {
        overflow: auto;
    }
    table {
        white-space: nowrap;
        text-align: center;
        width:  100%;
    }

    table td:first-child,
    table th:first-child {
        text-align: left;
    }
    table select {
        min-width: 56px;
        max-width: 80px;
    }
</style>

